import React, { useState, memo } from "react";
import { createBrowserHistory } from "history";
import MicroFrontend from "./MicroFrontend";
import { withRouter } from "react-router";

const defaultHistory = createBrowserHistory();

const {
  REACT_APP_INJECTABLE_MODULE_HOST : CommonHost,
  REACT_APP_ROUTE_ENV: hostUrl
} = process.env;

function MicrofrontendComponent(props) {
  const { history, privileges } = props;
  let containerId = props.id ? props.id : `${props.type}-container`;
  return (
    <div className="mfComponent">
      <MicroFrontend
        history={history}
        privileges={privileges}
        componentProps={props}
        host={hostUrl + CommonHost}
        name={props.type}
        containerId={containerId}
      />
    </div>
  );
}

function arePropsEqual(prevProps, nextProps) {
  if(nextProps.type === "ViewHistory"){
  return prevProps.id === nextProps.id && nextProps.type === "ViewHistory";
  } 
    if(nextProps.type === "InjectableComments"){
      return prevProps.id === nextProps.id && nextProps.type === "InjectableComments";
      }
}

export default memo(MicrofrontendComponent, arePropsEqual);

